module.exports = __webpack_public_path__ + "static/media/airenlei.412598e8.png";